// ─── API client fork ─────────────────────────────────────────────────────────
// Components import the API from '../api'. This module chooses the underlying
// implementation based on the build-time offline flag:
//   VITE_OFFLINE_MODE=true  → ./client     (frozen mock/dev client, no backend)
//   otherwise               → ./api-client (real backend client)
//
// NOTE: ./client is intentionally left untouched. The real implementation goes
// in ./api-client. The mirror of this flag lives in auth/AuthContext.tsx — fold
// both into a shared env module later if desired.
const OFFLINE_MODE = import.meta.env.VITE_OFFLINE_MODE === 'true'

import * as offlineClient from './client'
import * as onlineClient from './api-client'

const api = OFFLINE_MODE ? offlineClient : onlineClient

export const getBuyerRFQs                = api.getBuyerRFQs
// export const submitOrder                 = api.submitOrder
export const getSellerRFQs               = api.getSellerRFQs
export const getQuoteRequests            = api.getQuoteRequests
// export const getAuctionDetail            = api.getAuctionDetail
// export const getRfqDetail                = api.getRfqDetail
// export const submitOffer                 = api.submitOffer
export const getSellerInfo               = api.getSellerInfo
export const getBuyerDetails             = api.getBuyerDetails
export const getBuyerProvisioningForms   = api.getBuyerProvisioningForms
export const submitProvisioningForm      = api.submitProvisioningForm
export const getProvisioningForms        = api.getProvisioningForms
export const sendProvisioningForm        = api.sendProvisioningForm
export const acknowledgeForm             = api.acknowledgeForm
export const provisioningFormDownloadUrl = api.provisioningFormDownloadUrl
// export const submitBid                   = api.submitBid
// export const submitQuote                 = api.submitQuote
export const redeemFilter                = api.redeemFilter
export const FLASK_PORT                  = api.FLASK_PORT

// New backend-spec operations. These have no mock counterpart, so they are
// served by the real client regardless of VITE_OFFLINE_MODE.
export const getBuyerRFQ                  = onlineClient.getBuyerRFQ
export const getSellerRFQ                 = onlineClient.getSellerRFQ
export const openRfq                      = onlineClient.openRfq
export const awardQuote                   = onlineClient.awardQuote
export const declineRfqAsBuyer            = onlineClient.declineRfqAsBuyer
export const declineRfqAsSeller           = onlineClient.declineRfqAsSeller
export const downloadProvisioningLoa      = onlineClient.buyerDownloadProvisioningLoa

export type { ProvisioningForm, ProvisioningFormTemplate } from './client'
